import { render, staticRenderFns } from "./_receivableStatements.vue?vue&type=template&id=64724d23&scoped=true&"
import script from "./_receivableStatements.vue?vue&type=script&lang=js&"
export * from "./_receivableStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64724d23",
  null
  
)

export default component.exports